const toles = [
  {
    id: "metal-deploye",
    title: "Métal déployé",
    image: "/assets/images/products/Métal déployé.jpg",
    description: "Tôle étirée formant un réseau de mailles sans chutes",
    longDescription: "Le métal déployé est obtenu par découpe et étirement d'une tôle pleine, formant un réseau de mailles losanges sans perte de matière. Plus léger et plus rigide qu'une tôle perforée équivalente, il offre d'excellentes propriétés mécaniques pour des applications aussi diverses que le filtrage, le cloisonnement, les garde-corps ou les éléments décoratifs.",
    category: "toles",
    specifications: [
      "Épaisseur de la tôle d'origine: 0.5mm à 4mm",
      "Dimensions des mailles variables",
      "Poids réduit pour une résistance optimale",
      "Disponible en acier brut, galvanisé ou inoxydable",
      "Formats standards et découpes sur mesure"
    ]
  },
  {
    id: "tole-toitesco",
    title: "Tôle Toitesco",
    image: "/assets/images/products/Tôle Toitesco.webp",
    description: "Tôle spéciale pour toiture avec haute résistance",
    longDescription: "Tôle toitesco est la solution idéale pour les projets de toiture qui nécessitent une grande résistance, une durabilité, une flexibilité et une facilité d'installation. Ce matériau de toiture est fabriqué à partir d'une tôle d'acier galvanisé ou prélaqué, ce qui le rend résistant à la corrosion, à l'humidité et aux intempéries.",
    category: "toles",
    specifications: [
      "Épaisseur optimisée selon usage",
      "Profil exclusif Toitesco",
      "Revêtement haute durabilité",
      "Système de fixation sécurisé",
      "Garantie performance étendue"
    ]
  },
  {
    id: "tole-forte-laminee-chaud",
    title: "Tôle forte laminée à chaud",
    image: "/assets/images/products/Tôle laminée à chaud.webp",
    description: "Tôle épaisse pour applications lourdes et structurelles",
    longDescription: "Les tôles fortes laminées à chaud sont des tôles en acier de construction avec une surface matte et rugueuse utilisées comme des éléments porteurs dans l'industrie du bâtiment, de la construction navale et dans la constructions de citernes ou de ponts. Conforme aux normes NF EN 10025 et NF EN 10051.",
    category: "toles",
    specifications: [
      "Épaisseur: 5,00 - 150,00 mm",
      "Largeur: 1000 / 1250 / 1500 / 2000 mm",
      "Longueur: 2000 - 3000 - 6000 - 12 000 mm",
      "Acier S235 à S355",
      "Haute résistance à la charge"
    ]
  },
  {
    id: "tole-galvanisee",
    title: "Tôle galvanisée",
    image: "/assets/images/products/Tôle électro-zinguée.webp",
    description: "Tôle avec revêtement zinc protecteur contre la corrosion",
    longDescription: "L'acier galvanisé, trempé en continu présente une excellente résistance à la corrosion ainsi qu'une très bonne aptitude à la mise en forme. La galvanisation protège l'acier même en cas d'endommagement ou de mise à nu des tranches.",
    category: "toles",
    specifications: [
      "Épaisseur de 0.5mm à 3mm",
      "Revêtement disponible: Z100 ; Z150 ; 200 ; 225 ; 250 ; 275 ; 350 ; 450 g/m²",
      "Protection anticorrosion durable",
      "Formats standards et découpes sur mesure",
      "Disponible en finition fleur normale ou minimisée"
    ]
  },
  {
    id: "tole-striee-chaud",
    title: "Tôle laminée striée à chaud",
    image: "/assets/images/products/Tôle laminée striée à chaud.jpg",
    description: "Tôle antidérapante avec motif strié",
    longDescription: "Nos tôles striées laminées à chaud sont soumises à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Service sur-mesure.",
    category: "toles",
    specifications: [
      "Épaisseur de 3mm à 8mm (hors relief)",
      "Motif strié antidérapant",
      "Acier S235JR",
      "Formats standards et découpes sur mesure",
      "Résistance à l'usure"
    ]
  },
  {
    id: "tole-laminee-chaud",
    title: "Tôle laminée à chaud",
    image: "/assets/images/products/Tôle laminée à chaud.webp",
    description: "Tôle en acier laminée à chaud pour applications structurelles",
    longDescription: "Utilisées dans la construction et les bâtiments à structure légère. Ce sont des aciers au carbone et au manganèse. Bonne aptitude au soudage. Disponibles selon les grades : S235, S275, S355.",
    category: "toles",
    specifications: [
      "Épaisseur disponible: de 0.9mm à 15mm",
      "Formats standards et découpes sur mesure",
      "Acier S235 à S355",
      "Surface brute caractéristique",
      "Excellente aptitude au soudage et à la mise en forme"
    ]
  },
  {
    id: "tole-laminee-froid",
    title: "Tôle laminée à froid",
    image: "/assets/images/products/Tôle laminée à froid.webp",
    description: "Tôle fine avec surface lisse et précision dimensionnelle",
    longDescription: "Aciers pour formage à froid et emboutissage. Présentent une excellente aptitude au formage et emboutissage grâce à leurs caractéristiques mécaniques. Conformes à la norme EN 10130-2007.",
    category: "toles",
    specifications: [
      "Épaisseur: de 0.30mm à 3mm",
      "Normes: EN 10130 (DC 01, DC 03, DC 04), DIN 1623 (ST 12, ST 13, ST 14), JIS G3141 (SPCC, SDCD, SPCE), ASTM (A 366 CQ, A 619 DQ, A 620 DQSK)",
      "Surface lisse et régulière",
      "Tolérances dimensionnelles précises",
      "Excellente aptitude au pliage et à l'emboutissage"
    ]
  },
  {
    id: "tole-trouee",
    title: "Tôle trouée",
    image: "/assets/images/products/Tôle trouée.jpg",
    description: "Tôle perforée de trous réguliers pour filtration ou décoration",
    longDescription: "Nos tôles trouées sont soumises à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Nos spécialistes de la découpe vous proposent un service innovant, sur-mesure, façonnant l'ensemble de vos besoins et répondant à chacune de vos spécificités.",
    category: "toles",
    specifications: [
      "Épaisseur de 0.5mm à 3mm",
      "Perforations rondes, carrées ou personnalisées",
      "Diamètres des trous de 1mm à 20mm",
      "Disponible en acier brut, galvanisé ou inoxydable",
      "Formats standards et découpes sur mesure"
    ]
  },
  {
    id: "tole-nervuree",
    title: "Tôle nervurée",
    image: "/assets/images/products/Tôle nervurée.webp",
    description: "Tôle profilée avec nervures pour rigidité structurelle",
    longDescription: "Nos tôles nervurées sont soumises à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Nos spécialistes de la découpe vous proposent un service innovant, sur-mesure, façonnant l'ensemble de vos besoins et répondant à chacune de vos spécificités.",
    category: "toles",
    specifications: [
      "Épaisseur de 0.5mm à 1mm",
      "Hauteur des nervures de 18mm à 45mm",
      "Disponible en acier galvanisé ou prélaqué",
      "Longueurs sur mesure jusqu'à 12m",
      "Résistance aux charges climatiques (vent, neige)"
    ]
  },
  {
    id: "tole-ondulee",
    title: "Tôle ondulée",
    image: "/assets/images/products/Tôle ondulée.webp",
    description: "Tôle profilée avec ondulations régulières pour toiture économique",
    longDescription: "Nos tôles ondulées sont soumises à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Service sur-mesure.",
    category: "toles",
    specifications: [
      "Épaisseur de 0.5mm à 0.8mm",
      "Hauteur d'onde de 18mm à 30mm",
      "Disponible en acier galvanisé ou prélaqué",
      "Longueurs standard ou sur mesure",
      "Recouvrement latéral et longitudinal"
    ]
  },
  {
    id: "tole-micro-nervuree",
    title: "Tôle micro-nervurée",
    image: "/assets/images/products/Tôle micro-nervurée.webp",
    description: "Tôle avec fines nervures pour aspect esthétique et rigidité",
    longDescription: "Nos tôles micro-nervurées sont soumises à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Nos spécialistes de la découpe vous proposent un service innovant, sur-mesure, façonnant l'ensemble de vos besoins et répondant à chacune de vos spécificités.",
    category: "toles",
    specifications: [
      "Épaisseur de 0.5mm à 0.8mm",
      "Micro-nervures décoratives et fonctionnelles",
      "Disponible en acier prélaqué multicolore",
      "Longueurs sur mesure jusqu'à 12m",
      "Système de fixation invisible disponible"
    ]
  },
  {
    id: "tole-prelaquee",
    title: "Tôle prélaquée",
    image: "/assets/images/products/Tôle prélaquée.webp",
    description: "Tôle avec revêtement organique coloré et protecteur",
    longDescription: "Nos tôles prélaquées sont soumises à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Nos spécialistes de la découpe vous proposent un service innovant, sur-mesure, façonnant l'ensemble de vos besoins et répondant à chacune de vos spécificités.",
    category: "toles",
    specifications: [
      "Épaisseur de 0.5mm à 1.5mm",
      "Large palette de couleurs RAL",
      "Protection anticorrosion renforcée",
      "Garantie jusqu'à 15 ans selon finition",
      "Résistance aux UV et aux intempéries"
    ]
  },
  {
    id: "tole-perforee",
    title: "Tôle perforée",
    image: "/assets/images/products/Tôle perforée.webp",
    description: "Tôle avec perforations personnalisées pour applications spécifiques",
    longDescription: "La tôle perforée offre des motifs de perforations variés et personnalisables répondant à des besoins esthétiques ou fonctionnels spécifiques. Utilisée dans l'architecture, la décoration, l'acoustique, la filtration ou la ventilation, elle combine aspect décoratif et propriétés techniques.",
    category: "toles",
    specifications: [
      "Épaisseur de 0.5mm à 5mm",
      "Perforations rondes, carrées, oblongues ou designs spéciaux",
      "Taux de perforation de 10% à 70%",
      "Disponible en acier brut, galvanisé, inox ou aluminium",
      "Finitions diverses: brute, peinte, anodisée"
    ]
  },
  {
    id: "tole-larmee-chaud",
    title: "Tôle larmée laminée à chaud",
    image: "/assets/images/products/Tôle larmée laminée à chaud.webp",
    description: "Tôle antidérapante avec motif en larmes",
    longDescription: "Nos tôles larmées laminées à chaud sont soumises à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Service sur-mesure.",
    category: "toles",
    specifications: [
      "Épaisseur de 3/5mm à 8/10mm (tôle/relief)",
      "Motif en larmes antidérapant",
      "Acier S235JR",
      "Formats standards et découpes sur mesure",
      "Bonne résistance à l'abrasion"
    ]
  },
  {
    id: "tole-electrozinguee",
    title: "Tôle électro-zinguée",
    image: "/assets/images/products/Tôle électro-zinguée.webp",
    description: "Tôle avec revêtement zinc électrolytique fin et régulier",
    longDescription: "Nos tôles électrozinguées sont soumises à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Nos spécialistes de la découpe vous proposent un service innovant, sur-mesure, façonnant l'ensemble de vos besoins et répondant à chacune de vos spécificités.",
    category: "toles",
    specifications: [
      "Épaisseur de 0.5mm à 2mm",
      "Revêtement zinc électrolytique 5 à 25 μm",
      "Surface lisse et régulière",
      "Formats standards et découpes sur mesure",
      "Idéale pour les applications nécessitant peinture ou traitement ultérieur"
    ]
  },
];

export default toles;
